import { Skeleton } from 'primereact/skeleton';
import classes from './loading.module.scss';

const SalesPlanTableLoadingSkeleton = () => {
  return (
    <div className={classes.tabSkeletonSkeleton}>
      <div className={classes.tabSkeletonTable}>
        <Skeleton height="45rem"></Skeleton>
      </div>
    </div>
  );
};

export default SalesPlanTableLoadingSkeleton;
